module.exports = __webpack_public_path__ + "static/ball_ring-cead3fb96d5d1ee12f621fa69cf113ce.svg";